import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterStep1Img from '../Components/img/Register_Step1_HBT.png'

const NewRegister = () => {
    const [step, setStep] = useState(0);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const handleOtpChange = (value, index) => {
        if (/^\d*$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (value && index < 5) {
                document.getElementById(`otp-${index + 1}`).focus();
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!name.trim()) newErrors.name = 'Name is required';
        if (!email.trim()) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = 'Invalid email';
        if (!password) newErrors.password = 'Password is required';
        if (!confirmPassword) newErrors.confirmPassword = 'Confirm your password';
        else if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleContinue = () => {
        if (validateForm()) {
            setStep(1);
        }
    };

    return (
        <div className="new-register-main-hbt">
            <div className="new-register-section-hbt">
                <div className="new-register-container new-register-container1-hbt">

                </div>

                <div className="new-register-container new-register-container2-hbt">
                    {step === 0 && (
                        <div className="new-register-form-hbt">
                            <h2 className="new-register-heading-hbt">Create Your Account</h2>

                            <div className="new-register-inputwrapper-hbt">
                                <i className="fa fa-user new-register-icon-hbt" />
                                <input
                                    type="text"
                                    placeholder="Name"
                                    className="new-register-input-hbt"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            {errors.name && <p className="new-register-error-hbt">{errors.name}</p>}

                            <div className="new-register-inputwrapper-hbt">
                                <i className="fa fa-envelope new-register-icon-hbt" />
                                <input
                                    type="email"
                                    placeholder="Email"
                                    className="new-register-input-hbt"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            {errors.email && <p className="new-register-error-hbt">{errors.email}</p>}

                            <div className="new-register-inputwrapper-hbt">
                                <i className="fa fa-lock new-register-icon-hbt" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    className="new-register-input-hbt"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <i
                                    className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} new-register-toggle-hbt`}
                                    onClick={() => setShowPassword(!showPassword)}
                                />
                            </div>
                            {errors.password && <p className="new-register-error-hbt">{errors.password}</p>}

                            <div className="new-register-inputwrapper-hbt">
                                <i className="fa fa-lock new-register-icon-hbt" />
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    className="new-register-input-hbt"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <i
                                    className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} new-register-toggle-hbt`}
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                />
                            </div>
                            {errors.confirmPassword && <p className="new-register-error-hbt">{errors.confirmPassword}</p>}

                            <button className="new-register-btn-hbt" onClick={handleContinue}>
                                Continue
                            </button>

                            <p className="new-register-logintext-hbt">
                                Already have an account?{' '}
                                <span className="new-register-loginlink-hbt" onClick={() => navigate('/login')}>
                                    Login
                                </span>
                            </p>
                        </div>
                    )}

                    {step === 1 && (
                        <div className="new-register-otpform-hbt">
                            <h2 className="new-register-heading-hbt">Verify Your Email</h2>
                            <p className="new-register-otptitle-hbt">
                                OTP sent to <br /><strong>{email}</strong>
                            </p>

                            <div className="new-register-otpinputs-hbt">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`otp-${index}`}
                                        type="text"
                                        maxLength={1}
                                        className="new-register-otpinput-hbt"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e.target.value, index)}
                                    />
                                ))}
                            </div>

                            <p className="new-register-wrongemail-hbt">
                                Wrong email?{' '}
                                <span className="new-register-goback-hbt" onClick={() => setStep(0)}>
                                    Go back
                                </span>
                            </p>

                            <button className="new-register-btn-hbt">Verify OTP</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewRegister;
